import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { ClipboardText, FolderSimplePlus, ListChecks } from '@phosphor-icons/react';
import COLORS from '../../util/constants/colors';
import './chartActionsMenu.scss';

const ChartActionsMenu = ({
  canSendToChart,
  canCreateChart,
  canCreateTask,
  disableSendToChart,
  disableCreateChart,
  disableCreateTask,
  onSendToChart,
  onCreateChart,
  onCreateTask,
  sendLabel,
  createChartLabel,
  createTaskLabel,
}) => (
  <Menu className="chart-actions-menu" selectable={false}>
    {canSendToChart && (
      <Menu.Item
        key="send-to-chart"
        onClick={onSendToChart}
        disabled={disableSendToChart}
      >
        <span className="dropdown-icon"><ClipboardText size={20} weight="fill" color={COLORS.PURPLE_PRIMARY_LITE} /></span>
        <span>{sendLabel}</span>
      </Menu.Item>
    )}
    {canCreateChart && (
      <Menu.Item
        key="create-chart"
        onClick={onCreateChart}
        disabled={disableCreateChart}
      >
        <span className="dropdown-icon"><FolderSimplePlus size={20} color={COLORS.PURPLE_PRIMARY_LITE} /></span>
        <span>{createChartLabel}</span>
      </Menu.Item>
    )}
    {canCreateTask && (
      <Menu.Item
        key="create-task"
        onClick={onCreateTask}
        disabled={disableCreateTask}
      >
        <span className="dropdown-icon"><ListChecks size={20} color={COLORS.PURPLE_PRIMARY_LITE} /></span>
        <span>{createTaskLabel}</span>
      </Menu.Item>
    )}
  </Menu>
);

ChartActionsMenu.propTypes = {
  canSendToChart: PropTypes.bool,
  canCreateChart: PropTypes.bool,
  canCreateTask: PropTypes.bool,
  disableSendToChart: PropTypes.bool,
  disableCreateChart: PropTypes.bool,
  disableCreateTask: PropTypes.bool,
  onSendToChart: PropTypes.func,
  onCreateChart: PropTypes.func,
  onCreateTask: PropTypes.func,
  sendLabel: PropTypes.string,
  createChartLabel: PropTypes.string,
  createTaskLabel: PropTypes.string,
};

ChartActionsMenu.defaultProps = {
  canSendToChart: false,
  canCreateChart: false,
  canCreateTask: false,
  disableSendToChart: false,
  disableCreateChart: false,
  disableCreateTask: false,
  onSendToChart: () => {},
  onCreateChart: () => {},
  onCreateTask: () => {},
  sendLabel: 'Send to Chart',
  createChartLabel: 'Create Chart',
  createTaskLabel: 'Create Task',
};

export default ChartActionsMenu;
